var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"id":"iframe-lesson","src":_vm.iframeUrl,"frameborder":"0"},on:{"load":_vm.loaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }